var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaging = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0L24 0C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24L0 8Z",
    fill: "#E6FB66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5007 24V19.0645M11.5007 13V19.0645M11.5007 19.0645H18.5077C19.6122 19.0645 20.5077 18.1691 20.5077 17.0645V15.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5008 12C12.605 12 13.5015 11.1053 13.5015 10C13.5015 8.89471 12.605 8 11.5008 8C10.3965 8 9.5 8.89471 9.5 10C9.5 11.1053 10.3965 12 11.5008 12Z",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5076 15C21.6119 15 22.5084 14.1053 22.5084 13C22.5084 11.8947 21.6119 11 20.5076 11C19.4033 11 18.5068 11.8947 18.5068 13C18.5068 14.1053 19.4033 15 20.5076 15Z",
    stroke: "black",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaging);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staging.19d68c904b33bb560546280573e07718.svg";